import { Outlet } from "react-router-dom";
import classes from "./blogsListPage.module.css"

export const BlogsOutlet = () => {
  return (
    <div className={classes.outlet}>
      <Outlet />
    </div>
  );
};
